module.exports = __webpack_public_path__ + "static/img/211_TO8_2149_og.a777ff2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/211_TO8_2149_og.jpg
// module id = Td+9
// module chunks = 0